import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { ApiService } from '../../../../services/api';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';
import { PrintService } from '../../../../services/print-service';
import { RunDisplayHelper } from '../../../../lib/run-display-helper';
import { RunService } from '../../../../services/run.service';
import { DateHelperService } from '../../../../services/date-helper';

@Component({
    selector: 'page-judge-sheets-report',
    templateUrl: 'report-judge-sheets.html'

})
export class JudgeSheetsReport implements OnInit, OnDestroy {
    @Input('rodeo') rodeo: Rodeo;
    @Input('options') options: FormGroup;

    rodeoEvents: RodeoEvent[] = [];
    runDisplayHelper: RunDisplayHelper = RunDisplayHelper.instance();

    imageOrganization: string = '';

    popoverActive: boolean;
    dataLoaded: boolean;
    printing: boolean;

    schedulesToDisplay: any[] = [];
    hasNonPermitMembership: any[] = [];

    private subscriptions: Subscription[] = [];

    constructor(private navParams: NavParams, public api: ApiService, private datePipe: DatePipe, private printService: PrintService, private runService: RunService, public dateHelper: DateHelperService) { }

    ngOnInit(): void {
        if (!this.rodeo)
            this.rodeo = this.navParams.get('rodeo');        

        if (!this.options)
            return;

        //set up form listeners
        this.subscriptions.push(
            this.options.valueChanges.subscribe((e) => this.updateFromFormValues(e))
        );

        this.subscriptions.push(
            this.printService.printing.subscribe(printing => this.printing = printing)
        );

        //init the page
        this.updateFromFormValues(this.options.value);

        this.imageOrganization = this.rodeo.organization.logoFileName;
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(x => x.unsubscribe());
    }

    updateFromFormValues(filters) {
        if (filters.rodeoEventId > 0) {
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.id == filters.rodeoEventId);
        } else {
            const slack = !!filters.scheduleName && !!filters.scheduleName.toLowerCase().includes('slack');
            this.rodeoEvents = this.rodeo.rodeoEvents.filter(x => x.schedules && x.schedules.length > 0 && x.schedules.find(y => y.runs && y.runs.length > 0))
            .sort((a,b) => {
                if (a.eventOrders && b.eventOrders) {
                    return a.eventOrders.find(x => x.slack == slack).eventOrder - b.eventOrders.find(x => x.slack == slack).eventOrder;
                } else {
                    return a.id - b.id;
                }
            });;
        }

        // console.log(this.rodeoEvents);
        // console.log('filters', this.options.value);
        this.updateRodeoEvents(filters);
        this.dataLoaded = true;
    }

    updateRodeoEvents(filters) {
        this.schedulesToDisplay = [];

        this.rodeoEvents.forEach((rodeoEvent) => {
            rodeoEvent.registrations.forEach(registration => {
				if (registration.contestantOne.memberships.some(x => !x.permit && !x.isExpired && this.rodeo.organization.memberships.some(y => y.id == x.membershipId))) {
					this.hasNonPermitMembership[registration.contestantOne.id] = true;
                }

				if (registration.contestantTwo && registration.contestantTwo.memberships.some(x => !x.permit && !x.isExpired && this.rodeo.organization.memberships.some(y => y.id == x.membershipId))) {
					this.hasNonPermitMembership[registration.contestantTwo.id] = true;
                }
            });
            
            rodeoEvent.schedules
                .sort((a, b) => new Date(a.scheduledDate).getTime() - new Date(b.scheduledDate).getTime())
                .forEach((schedule) => {                    
                    if (filters.scheduleName && filters.scheduleName !== "" && filters.scheduleName !== schedule.name)
                        return;

                    if (filters.round > 0) {
                        let scheduleToAdd = { ...schedule, runs: this.runService.getRuns(this.rodeo, rodeoEvent, schedule, filters.round) };

                        if (scheduleToAdd.runs.length > 0) {
                            if (!this.schedulesToDisplay[schedule.id]) {
                                this.schedulesToDisplay[schedule.id] = [];
                            }

                            this.schedulesToDisplay[schedule.id].push(scheduleToAdd);
                        }
                    } else {
                        var scheduleRounds = [...new Set(schedule.runs.map(x => x.round))];

                        scheduleRounds.forEach((round) => {
                            let scheduleToAdd = { ...schedule, runs: this.runService.getRuns(this.rodeo, rodeoEvent, schedule, round) };

                            if (scheduleToAdd.runs.length > 0) {
                                if (!this.schedulesToDisplay[schedule.id]) {
                                    this.schedulesToDisplay[schedule.id] = [];
                                }

                                this.schedulesToDisplay[schedule.id].push(scheduleToAdd);
                            }
                        });
                    }
            });
        });
    }

    // shouldWriteDragLine(rodeoEvent, schedule, run, runIndex) {
    //     if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.runs[schedule.id].length || (rodeoEvent.eventType != 'BarrelRacing' && rodeoEvent.eventType != 'PoleBending'))
    //         return false;

    //     let nextRun = this.runs[schedule.id][runIndex + 1];

    //     if ((rodeoEvent.reverseSecondRound || rodeoEvent.reverseSecondRoundDragOnly) && this.options.value.round == 2) {
    //         nextRun = run;
    //         run = this.runs[schedule.id][runIndex + 1];
    //     }

    //     let lastDragCount = Math.floor(+run.number / +rodeoEvent.dragEvery);
    //     let currentDragCount = Math.floor(+nextRun.number / +rodeoEvent.dragEvery);

    //     if ((currentDragCount > lastDragCount && +nextRun.number % +rodeoEvent.dragEvery != 0) || +run.number % +rodeoEvent.dragEvery == 0)
    //         return true;

    //     return false;
    // }

    // shouldWriteBigDragLine(rodeoEvent, schedule, run, runIndex) {
    //     if (rodeoEvent.dragEvery == 0 || run == null || runIndex + 1 >= this.runs[schedule.id].length || (rodeoEvent.eventType != 'BarrelRacing' && rodeoEvent.eventType != 'PoleBending'))
    //         return false;

    //     let nextRun = this.runs[schedule.id][runIndex + 1];

    //     if ((rodeoEvent.reverseSecondRound && !rodeoEvent.reverseSecondRoundDragOnly) && this.options.value.round == 2) {
    //         nextRun = run;
    //         run = this.runs[schedule.id][runIndex + 1];
    //     }

    //     let lastBigDragCount = Math.floor((+run.number - 1) / +rodeoEvent.bigDragEvery);
    //     let currentBigDragCount = Math.floor((+nextRun.number - 1) / +rodeoEvent.bigDragEvery);

    //     if ((currentBigDragCount > lastBigDragCount && +nextRun.number % +rodeoEvent.bigDragEvery != 0) || +run.number % +rodeoEvent.bigDragEvery == 0)
    //         return true;

    //     return false;
    // }

    // shouldPageBreak(index) {
    //     return this.rodeo.rodeoEvents[index].schedules.some(x => (x as any).showJudges && x.runs.length > 0)
    //         && this.rodeo.rodeoEvents.length > index + 1
    //         && this.rodeo.rodeoEvents[index + 1].schedules.some(x => (x as any).showJudges && x.runs.length > 0);
    // }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }

    getPenaltyMessage(rodeoEvent, run) {
        var message = rodeoEvent.eventType.indexOf('Barrel') != -1 ? ' Barrel' : ' Pole';
        var count = +(run.penaltyTime / rodeoEvent.barrelPenalty).toFixed(0);

        if (count > 1)
            return count + message + "s";
        else
            return count + message;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-judge-sheets.ts